import { render, staticRenderFns } from "./DateTimeWithNote.vue?vue&type=template&id=195d24ed&"
import script from "./DateTimeWithNote.vue?vue&type=script&lang=js&"
export * from "./DateTimeWithNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports